/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Akzeptieren und fortfahren',
    APPROVE: 'Zustimmen',
    CANCEL: 'Abbrechen',
    SAVE: 'Speichern'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX:
      'Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie',
    ACCEPT_TERMS_DESCRIPTION:
      'Bevor Sie auf die Prozis Partnership-Plattform zugreifen, lesen und akzeptieren Sie bitte die Allgemeinen Geschäftsbedingungen des Prozis Influencer Programms.',
    ACCEPT_TERMS_NAV_TITLE: 'Allgemeine Geschäftsbedingungen',
    ACCEPT_TERMS_SCROLL_HINT: 'Bitte lesen Sie bis zum Ende, um fortzufahren.',
    DASHBOARD: 'Dashboard',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'Wir haben festgestellt, dass bei Ihnen keine Benachrichtigungen aktiv sind. Um die App weiterhin nutzen zu können, müssen Sie die Benachrichtigungen aktivieren.',
    ENABLE_NOTIFICATIONS_LINK: 'Hier können Sie Benachrichtigungen aktivieren',
    ENABLE_NOTIFICATIONS_NAV_TITLE: 'Benachrichtigungen',
    ENABLE_NOTIFICATIONS_TITLE:
      'Aktivieren Sie Benachrichtigungen, damit Sie fortfahren können',
    HOME: 'Startseite',
    INSTALL_PROZIS_APP: 'Prozis Store App installieren',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Installieren Sie unsere mobile App, um weiterhin alle Funktionen nutzen zu können.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'App installieren',
    LOGOUT: 'Abmelden',
    NOT_FOUND: 'Nicht gefunden',
    OR: 'Oder',
    OR_SCAN_QR_CODE: 'Oder scannen Sie den QR-Code',
    SCAN_QR_CODE: 'Scannen Sie den QR-Code mit Ihrem mobilen Gerät',
    TODOS: 'Alle',
    UNAUTHORIZED_DESCRIPTION_1:
      'Erkundigen Sie sich bei Ihrem Vorgesetzten nach den Zugriffsberechtigungen.',
    UNAUTHORIZED_DESCRIPTION_2:
      'Versuchen Sie nach der Überprüfung erneut, sich anzumelden.',
    UNAUTHORIZED_NAV_TITLE: 'Zugriff verweigert',
    UNAUTHORIZED_TITLE: 'Keine Zugriffsberechtigung'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
